import { getInstanceId } from "../../Utils/utils";
import { TutorManager } from "./TutorManager";


export function loadTutorManagement(){
    const instanceId = getInstanceId();

    new TutorManager(instanceId);
}